/**
 * Rutas del panel admin — sin detección geo/i18n del sitio público.
 * El admin debe cargar rápido y no forzar español por país del visitor.
 */

export function isAdminAppPath(pathname?: string): boolean {
  if (typeof window === "undefined" && pathname == null) return false;
  const raw = (pathname ?? window.location.pathname).trim() || "/";
  const p = raw.length > 1 && raw.endsWith("/") ? raw.slice(0, -1) : raw;
  return (
    p === "/admin" ||
    p.startsWith("/admin/") ||
    p === "/dashboard" ||
    p.startsWith("/dashboard/")
  );
}